// @ts-nocheck
import { SxProps, Theme } from '@mui/material'
import { experimentalStyled } from '@mui/material/styles'
import type { FC, ReactNode } from 'react'
import React, { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import DashboardNavbar from './DashboardNavbar'
import DashboardSidebar from './DashboardSidebar'
import useCollapsed from 'src/hooks/useCollapsed'
import PATHS from 'src/common/constants/paths'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

interface DashboardLayoutProps {
    children?: ReactNode
}

const DashboardLayoutRoot = experimentalStyled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    height: '100%',
    zIndex: '1600',
    width: '100%',
}))
const DashboardLayoutContent = experimentalStyled('div')<defaultDashboardProp>(({ theme, padding, paddingTop }) => ({
    display: 'flex',
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
    position: 'relative',
    WebkitOverflowScrolling: 'touch',
    paddingTop: paddingTop,
    [theme.breakpoints.up('lg')]: {
        paddingLeft: padding,
        transition: 'padding 0.3s ease',
    },
}))

interface defaultProp {
    theme?: Theme
    as?: React.ElementType
    sx?: SxProps<Theme>
    styleProps?: Record<string, unknown>
}

interface defaultDashboardProp extends defaultProp {
    padding?: string
    paddingTop?: string
}

const DashboardLayout: FC<DashboardLayoutProps> = () => {
    const { collapsed, toggleCollapsed } = useCollapsed(true)
    const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState<boolean>(false)

    const location = useLocation()
    const paddingTop = [PATHS.DASHBOARD.SECONDARY_TOP_SELLING, PATHS.DASHBOARD.HISTORICAL_DATA].includes(
        location.pathname
    )
        ? '0px'
        : '64px'

    const theme = useTheme<Theme>()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    return (
        <DashboardLayoutRoot>
            <DashboardNavbar
                onSidebarMobileOpen={(): void => setIsSidebarMobileOpen(true)}
                isMobile={isMobile}
                isSidebarMobileOpen={isSidebarMobileOpen}
                setIsSidebarMobileOpen={setIsSidebarMobileOpen}
            />
            <DashboardSidebar
                collapsed={collapsed}
                setCollapsed={toggleCollapsed}
                onMobileClose={(): void => setIsSidebarMobileOpen(false)}
                openMobile={isSidebarMobileOpen}
                isMobile={isMobile}
                isSidebarMobileOpen={isSidebarMobileOpen}
                setIsSidebarMobileOpen={setIsSidebarMobileOpen}
            />
            <DashboardLayoutContent padding={isMobile ? '16px' : collapsed ? '70px' : '240px'} paddingTop={paddingTop}>
                <Outlet />
            </DashboardLayoutContent>
        </DashboardLayoutRoot>
    )
}

export default DashboardLayout
